import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone'
})
export class TelefonePipe implements PipeTransform {
  transform(telefone: string): string {
    if (!telefone) return '';

    // Remove tudo que não for número
    const numeros = telefone.replace(/\D/g, '');

    // Verifica se o número tem 10 (fixo) ou 11 (celular) dígitos
    if (numeros.length === 10) {
      // Formato: (99) 9999-9999
      const ddd = numeros.slice(0, 2);
      const parte1 = numeros.slice(2, 6);
      const parte2 = numeros.slice(6);
      return `(${ddd}) ${parte1}-${parte2}`;
    } else if (numeros.length === 11) {
      // Formato: (99) 9 9999-9999
      const ddd = numeros.slice(0, 2);
      const parte1 = numeros.slice(2, 3); // o 9
      const parte2 = numeros.slice(3, 7);
      const parte3 = numeros.slice(7);
      return `(${ddd}) ${parte1} ${parte2}-${parte3}`;
    }

    // Se não tiver 10 ou 11 dígitos, retorna o valor original
    return telefone;
  }
}